export default __webpack_public_path__ + "static/media/imgappfeatures.bea70c8a.png";